var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaylist({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 8L4 8",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13.3335L4 13.3335",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 18.6665H4.00008",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 24H4.00008",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1667 18.8245C27.3719 20.0976 28.4744 20.7341 28.6364 21.6526C28.6769 21.8824 28.6769 22.1174 28.6364 22.3472C28.4744 23.2656 27.3719 23.9022 25.1667 25.1753C22.9616 26.4484 21.8591 27.085 20.9827 26.766C20.7635 26.6862 20.5599 26.5687 20.3812 26.4187C19.6667 25.8193 19.6667 24.5461 19.6667 21.9999C19.6667 19.4536 19.6667 18.1805 20.3812 17.581C20.5599 17.4311 20.7635 17.3135 20.9827 17.2338C21.8591 16.9148 22.9616 17.5513 25.1667 18.8245Z",
    stroke: "#172B4D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylist);
export default __webpack_public_path__ + "static/media/playlist.3fafe0d97fc85666f8f2ec1aaafca106.svg";
export { ForwardRef as ReactComponent };